// extracted by mini-css-extract-plugin
export var pillWrapper = "_o7-0";
export var showOverflow = "_o7-1";